import React, {Component, Fragment} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {formsDataUpdater, getFormFieldValue} from "../../Applications/shared/shared";
import {EventClient} from "../../../util/eventClient";
import {getData} from "../../../api/doLogin";
import {MakeDialog} from "../../../components/Shared/MakeDialog";
import './lmsentry.css';
import {hasPermission, RequiredPermission} from "../../../api/permissionHelper";
import {toast} from "react-toastify";

export default class LMSDuplicateLookup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      lmsId: null,
      appttypes: [],
      dataLoaded: true,
      formData: {}, // Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      activeTab: "1",
      hideButtons: false,
      highlightErrors: {} // This is for highlighting errors in the form
    };
    // console.log("Loaded fileeditor");
  }

  componentWillMount() {
    EventClient.on("LMS_ENTRY_LOOKUP", (options) => this.setState({
      open: true,
      formData: {
        fid: options.fid || 1,
        folderPath: options.folderPath || "",
        homeemail: options.homeemail || "",
        homephone: options.homephone || "",
        cellphone: options.cellphone || "",
        dcStatus: "100",
        status: "1"
      },
      highlightErrors: {},
      dataLoaded: true,
      hideButtons: false,
      activeTab: "1"
    }), "LMSDuplicateLookup");

  }

  componentWillUnmount() {
    EventClient.off("LMS_ENTRY_LOOKUP", () => {
    }, "LMSDuplicateLookup");
  }

  closeMe() {
    this.setState({
      open: false,
      dataLoaded: false,
      formData: {},
      activeTab: "1",
      highlightErrors: {},
    });
  }

  save(edit = false) {
    const payload = this.state.formData || {};
    //console.log(payload);
    if (!payload['homeemail'] && !payload['homephone'] && !payload['cellphone']) {
      toast.error("Please enter a home/cell phone number or home email");
      return;
    }
    if (!this.state.lmsId) {
      this.quickLookup([payload['homeemail'], payload['homephone'], payload['cellphone']], (totalResults) => {
        if (totalResults > 0) {
          let q = [payload['homeemail'], payload['homephone'], payload['cellphone']].filter((value) => value && value.length > 0).join(" ");
          EventClient.emit("NAVIGATE", {path: '/lookup/search', data: {q}});
          this.closeMe();
        } else {
          EventClient.emit("LMS_ENTRY_ADD", {
            fid: this.state.formData['fid'] || 1,
            folderPath: this.state.formData['folderPath'] || "",
            homeemail: payload['homeemail'],
            homephone: payload['homephone'],
            cellphone: payload['cellphone'],
          });
          this.closeMe();
        }
      });
    }
  }

  proceedAnyway() {
    EventClient.emit("LMS_ENTRY_ADD", {
      fid: this.state.formData['fid'] || 1,
      folderPath: this.state.formData['folderPath'] || "",
      homeemail: this.state.formData['homeemail'] || "",
      homephone: this.state.formData['homephone'] || "",
      cellphone: this.state.formData['cellphone'] || "",
    });
    this.closeMe();
  }

  quickLookup(values, cb) {
    const self = this;
    const searchData = {
      q: values.map((value) => (value || "").trim()).join(" ").replace(/\s+/g, " "),
      page: 1,
      limit: 10
    };
    getData("lms/leads", searchData)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          //   data: data.data.leads,
          let totalResults = Number(data.data.results);
          cb(totalResults);
        } else {
          toast.error("Could not compare to other leads");
        }
      })
      .catch(error => {
        toast.error("Could not compare to other leads");
        console.error(error);
      });
  }

  quickFieldCheck(field, formData, self) {
    if (this.state.lmsId) return;
    if (field === "homeemail" || field === "homephone" || field === "cellphone") {
      let value = formData[field];
      if (value && value.length > 0) {
        self.quickLookup([value], (totalResults) => {
          if (totalResults > 0) {
            self.setState({
              highlightErrors: {
                ...self.state.highlightErrors,
                [field]: true
              }
            });
          } else {
            self.setState({
              highlightErrors: {
                ...self.state.highlightErrors,
                [field]: false
              }
            });
          }
        });
      } else {
        self.setState({
          highlightErrors: {
            ...self.state.highlightErrors,
            [field]: false
          }
        });
      }
    }
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    if (!this.state.open) return null;
    return (
      <MakeDialog isOpen={this.state.open}
                  header="Quick lookup"
                  footer={(
                    <Fragment>
                      {!this.state.hideButtons && (
                        <Fragment>
                          {hasPermission(RequiredPermission.LMSSave) && (
                            <Fragment>
                              <Button color="primary"
                                      onClick={() => this.save()}>Lookup</Button>
                              <Button color="info"
                                      onClick={() => this.proceedAnyway()}>Continue Anyway</Button>
                            </Fragment>
                          )}
                          <Button color="secondary"
                                  onClick={() => this.closeMe()}>Close</Button>
                        </Fragment>
                      )}
                    </Fragment>
                  )}>
        {!this.state.dataLoaded ?
          <Fragment>Loading
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </Fragment>
          :
          <Fragment>
            <Row>
              <Col lg={12} md={12} sm={12} xs={12}>
                <span>
                  <strong>Attention:</strong> To address the issue of duplicate leads, please ensure to thoroughly verify identifying information before entry. We're working on a system update to prevent duplicates. Your diligence is appreciated.
                </span>
              </Col>
            </Row>
            <Row style={{marginTop: 5}}>
              <Col lg={4} md={6} sm={12} xs={12}>
                <FormGroup>
                  <Label for="cellphone">Cell Phone</Label>
                  <Input
                    type="text"
                    id="cellphone"
                    autoFocus
                    value={getFormFieldValue(this.state.formData['cellphone'])}
                    onChange={(evt) => formsDataUpdater("cellphone", evt.target.value.replace(/[^0-9]/g, ''), this.state['formData'], this)}
                    valid={!this.state.highlightErrors['cellphone']}
                    onBlur={() => this.quickFieldCheck('cellphone', this.state.formData, this)}
                  />
                  {this.state.highlightErrors['cellphone'] && (<span style={{color: "red"}}>Duplicate Detected</span>)}
                </FormGroup>
              </Col>
              <Col lg={4} md={6} sm={12} xs={12}>
                <FormGroup>
                  <Label for="homephone">Home Phone</Label>
                  <Input
                    type="text"
                    id="homephone"
                    value={getFormFieldValue(this.state.formData['homephone'])}
                    onChange={(evt) => formsDataUpdater("homephone", evt.target.value.replace(/[^0-9]/g, ''), this.state['formData'], this)}
                    valid={!this.state.highlightErrors['homephone']}
                    onBlur={() => this.quickFieldCheck('homephone', this.state.formData, this)}
                  />
                  {this.state.highlightErrors['homephone'] && (<span style={{color: "red"}}>Duplicate Detected</span>)}
                </FormGroup>
              </Col>
              <Col lg={4} md={6} sm={12} xs={12}>
                <FormGroup>
                  <Label for="homeemail">Home Email</Label>
                  <Input
                    type="text"
                    id="homeemail"
                    value={getFormFieldValue(this.state.formData['homeemail'])}
                    onChange={(evt) => formsDataUpdater("homeemail", evt.target.value, this.state['formData'], this)}
                    valid={!this.state.highlightErrors['homeemail']}
                    onBlur={() => this.quickFieldCheck('homeemail', this.state.formData, this)}
                  />
                  {this.state.highlightErrors['homeemail'] && (<span style={{color: "red"}}>Duplicate Detected</span>)}
                </FormGroup>
              </Col>
            </Row>
          </Fragment>
        }
      </MakeDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Leads/modals/LMSDuplicateLookup.js